class EnumService {
  constructor () {
    this.operatorStatuses = {
      0: 'Unknown',
      67: 'Occasional',
      69: 'Excluded',
      78: 'Nondriver',
      79: 'Only',
      80: 'Principal',
      82: 'Permitonly',
      83: 'Suspended',
      85: 'UnratedDriver'
    };

    this.maritalStatuses = {
      0: 'Unknown',
      67: 'Domestic Partner Unmarried',
      68: 'Divorced',
      69: 'Separated',
      70: 'Fiance',
      73: 'Divorced With Children',
      77: 'Married',
      80: 'Separated With Children',
      83: 'Single',
      86: 'Civil Union',
      87: 'Widowed'
    };

    this.genders = {
      0: 'Unknown',
      70: 'Female',
      77: 'Male',
      88: 'Non-binary'
    };

    this.educationLevels = {
      0: 'Unknown',
      49: 'College 1 Year',
      50: 'College 2 Year',
      51: 'College 3 Year',
      52: 'College 4 Year',
      65: 'Associates Degree',
      66: 'Bachelors Degree',
      67: 'Some College',
      68: 'Doctor Of Medicine',
      69: 'Doctor Of Dentistry',
      71: 'GED',
      72: 'High School',
      76: 'Law Degree',
      77: 'Masters Degree',
      80: 'PhD',
      82: 'Post Graduate',
      83: 'Less Than High School Diploma',
      84: 'Vocational Technical',
      86: 'Doctor Of Veterinary Medicine'
    };

    this.vehicleCoverageTypes = {
      0: 'Unknown',
      1: 'All Owned Autos',
      2: 'Any Auto',
      3: 'Broad Form',
      4: 'Drive Other Car',
      5: 'Hired',
      6: 'Non Owned',
      7: 'Scheduled Auto'
    };

    this.autoUseTypes = {
      0: 'Unknown',
      63: 'Blank',
      65: 'Artisan',
      66: 'Business',
      67: 'Commercial',
      70: 'Farm',
      72: 'ForHire',
      80: 'Pleasure',
      82: 'Retail',
      83: 'Service',
      87: 'Work'
    };

    this.autoBodyStyles = {
      0: 'Unknown',
      1: 'Coupe',
      2: 'Coupe Hatchback',
      3: 'Convertible',
      4: 'Sedan',
      5: 'Hatchback',
      6: 'Fastback',
      7: 'Liftback',
      8: 'Notchback',
      9: 'TTop',
      10: 'Stationwagon',
      11: 'Limousine',
      12: 'Utility',
      13: 'Multi Purpose',
      14: 'Multi Purpose Extended',
      15: 'Bus',
      16: 'Bus Extended',
      17: 'Van',
      18: 'Van Extended',
      19: 'Pickup Regular Cab',
      20: 'Pickup Super Cab',
      21: 'Pickup Crew Cab',
      22: 'Other',
      23: 'Trailer PD Only',
      24: 'Passenger',
      25: 'Pickup',
      26: 'RV',
      27: 'Sport Utility',
      28: 'Commercial Trailer',
      29: 'Util',
      30: 'Truck',
      31: 'Mini Van',
      32: 'Motorcycle'
    };

    this.airBagTypes = {
      0: 'None',
      1: 'Driver Side Only',
      2: 'Both'
    };

    this.autoAntiTheftTypes = {
      0: 'None',
      1: 'Passive',
      2: 'Active'
    };

    this.commercialVehicleTypes = {
      0: 'Unknown',
      67: 'Commercial Vehicle',
      80: 'Private Passenger',
      83: 'Specialty Vehicle'
    };

    this.boatConstructionTypes = {
      0: 'Unknown',
      70: 'Fiberglass',
      73: 'InflatableOrFabric',
      77: 'Metal',
      79: 'Other',
      87: 'Wood'
    };

    this.boatFuelTypes = {
      0: 'Unknown',
      66: 'Battery',
      68: 'Diesel',
      71: 'Gas',
      79: 'Other'
    };

    this.boatPropulsionTypes = {
      0: 'Unknown',
      1: 'OB',
      2: 'IO',
      3: 'IB',
      4: 'Sail',
      5: 'Drift',
      6: 'Waterjet',
      7: 'Pod Drive'
    };

    this.boatStorageTypes = {
      0: 'Unknown',
      77: 'Marina',
      79: 'Other',
      84: 'Trailer'
    };

    this.boatTypes = {
      0: 'Unknown',
      65: 'Trailer',
      66: 'Bass',
      67: 'Cruiser',
      68: 'Drift',
      69: 'OpenCockpit',
      72: 'Houseboat',
      73: 'HighPerformance',
      74: 'Jet',
      77: 'MotorYacht',
      79: 'Other',
      80: 'PersonalWatercraft',
      81: 'Equipment',
      82: 'RunaboutOrSki',
      83: 'Sail',
      84: 'Trawler',
      87: 'Waverunner',
      89: 'Motor'
    };

    this.boatUseTypes = {
      0: 'Unknown',
      66: 'BareboatCharter',
      67: 'CrewedCharter',
      69: 'Rental',
      71: 'Guide',
      77: 'Commercial',
      79: 'Other',
      80: 'Pleasure',
      82: 'Racing',
      87: 'WaterSki'
    };

    this.dwellingResidenceType = {
      0: 'Unknown',
      65: 'Apartment',
      67: 'Condo',
      68: 'Dwelling',
      77: 'Mobile Home',
      79: 'Other',
      80: 'Co-op',
      82: 'Row House',
      84: 'Townhouse'
    };

    this.occupancyType = {
      0: 'Unknown',
      79: 'Owner',
      84: 'Tenant',
      85: 'Unoccupied',
      86: 'Vacant'
    };

    this.dwellingUseType = {
      0: 'Unknown',
      49: 'Primary (non-seasonal)',
      51: 'Secondary (non-seasonal)',
      52: 'Secondary (seasonal)',
      53: 'Other',
      54: 'Farm',
      55: 'Vacant',
      56: 'Occasionally Occupied',
      57: 'Course Of Construction (COC)'
    };

    this.dwellingLocation = {
      0: 'Unknown',
      67: 'In City Limits, non-fringe',
      68: 'Fire District',
      69: 'Outside City Limits, fringe',
      70: 'In City Limits, fringe',
      79: 'Other',
      83: 'Suburban'
    };

    this.roofMaterialType = {
      0: 'Unknown',
      65: 'Composition',
      66: 'Asbestos Shakes',
      67: 'Copper',
      68: 'Cedar Shakes',
      69: 'Steel/Porcelain Shingles',
      70: 'Plastic',
      71: 'Recycled',
      72: 'Roll Roofing',
      73: 'Membrane',
      74: 'Tar & Gravel',
      76: 'Cedar Shingles',
      77: 'Metal ', // brutal
      78: 'Concrete Tile',
      79: 'Other',
      80: 'Poured',
      82: 'Rock',
      83: 'Slate',
      84: 'Tile',
      85: 'Aluminum Shingles',
      87: 'Wood Shingle',
      89: 'Clay Tile'
    };

    this.homeHeatSourceType = {
      0: 'Unknown',
      67: 'Coal Professionally Installed',
      68: 'Coal Non-Professionally Installed',
      69: 'Electric',
      70: 'Electric Portable Heater',
      71: 'Natural Gas',
      72: 'Kerosene Portable Heater',
      75: 'Kerosene',
      76: 'Liquid Propane Gas',
      77: 'Liquid Propane Portable Heater',
      78: 'None',
      79: 'Oil', // I drink your milkshake!
      80: 'Electric - Heat Pump',
      82: 'Other',
      83: 'Solar Professionally Installed',
      84: 'Solar Non-Professionally Installed',
      85: 'Water - Electrically Heated',
      86: 'Water - Gas Heated',
      87: 'Wood Professionally Installed',
      88: 'Wood Non-Professionally Installed'
    };

    this.dwellingStories = {
      0: 'Unknown',
      49: '1',
      50: '2',
      51: '3',
      52: '4',
      65: '1.5',
      66: '2.5',
      67: 'Bi-Level',
      68: 'Split-Level',
      69: 'Three or More',
      70: 'Tri-Level'
    };

    this.improvementStatus = {
      0: 'Not Answered',
      67: 'Complete',
      78: 'No Improvements',
      80: 'Partial'
    };

    this.swimmingPoolExposureType = {
      0: 'Unknown',
      48: 'None',
      49: 'Above Ground, Approved Fence Height',
      50: 'Above Ground, Unapproved Fence Height',
      51: 'In Ground, Approved Fence Height',
      52: 'In Ground, Unapproved Fence Height',
      53: 'Above Ground, Unfenced',
      54: 'In Ground, Unfenced',
      55: 'Abv Grnd, Lmt. Access, Not Appr. Fence'
    };

    this.trampolineType = {
      0: 'Unknown',
      48: 'None',
      49: 'Above Ground, w/ Safety Net',
      50: 'Above Ground w/o Safety Net',
      51: 'In Ground w/ Safety Net',
      52: 'In Ground w/o Safety Net'
    };

    this.boatPropulsionType = {
      0: 'Unknown',
      1: 'OB',
      2: 'IO',
      3: 'IB',
      4: 'SA',
      5: 'DR',
      6: 'WA',
      7: 'PO'
    };

    this.buildingConstructionType = {
      0: 'Unknown',
      1: 'Mobile',
      2: 'Frame',
      3: 'Masonry',
      4: 'Masonry Ven.',
      5: 'Metal / Plastic',
      6: 'Metal / Aluminum',
      7: 'Plastic Siding',
      8: 'Pre-Fab.',
      9: 'Superior',
      10: 'Earth Shelter',
      11: 'Trailer',
      12: 'Asbest. & Stucco',
      13: 'Adobe',
      14: 'Log',
      15: 'Concrete Block',
      16: 'Other'
    };

    this.policyStatus = {
      0: 'Unknown',
      1: 'New',
      2: 'Active',
      3: 'Renewal',
      4: 'Cancelled',
      5: 'DeadFiled',
      6: 'Prospect',
      7: 'NonRenew',
      8: 'Purge',
      9: 'Void',
      10: 'Suspect',
      11: 'Quote',
      12: 'Refused',
      13: 'Replaced',
      14: 'Expired',
      15: 'Rewrite',
      16: 'Lead',
      17: 'Rejected',
      18: 'Reinstate'
    };

    this.scheduleValuationType = {
      48: 'Unknown',
      65: 'Actual Cash Value',
      66: 'Business Income Changes Time Period',
      67: 'Agreed Amount (Waived Coinsurance And Replacement Cost)',
      68: 'Reproduction',
      69: 'Agreed Amount (Waived Coinsurance)',
      70: 'Functional Replacement Cost',
      71: 'Guaranteed Replacement Cost',
      73: 'Invoice Cost',
      76: 'Actual Loss Sustained',
      77: 'Market Value',
      80: 'Selling Price',
      82: 'Replacement Cost',
      83: 'Stated Amount',
      84: 'Total Insured Value',
      85: 'Full Value Replacement Cost',
      86: 'Agreed Value (Inland Marine Only)',
      88: 'Extended Value Replacement Cost'
    };

    this.animalBreed = {
      0: 'Akita',
      1: 'Boxer',
      2: 'Chow Chow',
      3: 'Doberman',
      4: 'German Shepherd',
      5: 'Great Dane',
      6: 'Husky',
      7: 'Mix of any of the listed breeds',
      8: 'Not Asked',
      9: 'Other',
      10: 'Pitbull',
      11: 'Rottweiler',
      12: 'Wolf Hybrid'
    };

    this.animalType = {
      0: 'Cattle',
      1: 'Dog',
      2: 'Horse',
      3: 'Other'
    };
  }
}

var x = new EnumService();
export default x;
